import { FadeLoader } from "react-spinners"

/* This loader shows the loading with height of 80vh to cover the part of body */

const Loader = ({ height, width }) => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{height: `${height ?? '100vh'}`, position: 'absolute', top: 47, left: 0, background: 'rgba(0,0,0,0.3)', width: `${width ?? '100%'}`}}>
            <FadeLoader color="rgb(21, 140, 186)"/>
        </div>
    )
}

export default Loader